import Box from '@redbubble/design-system/src/Box';
import * as constants from '@redbubble/design-system/src/constants';
import ChevronRightIcon from '@redbubble/design-system/src/Icons/ChevronRight';
import Stack from '@redbubble/design-system/src/Stack';
import TextLink from '@redbubble/design-system/src/TextLink';
import { useIntl } from '@redbubble/next/intl';
import { messages } from '../messages';

export interface SizingInformationProps {
  localisedLink: string;
}

export const SizingInformation = ({
  localisedLink,
}: SizingInformationProps) => {
  const intl = useIntl();

  return (
    <Stack direction={constants.HORIZONTAL} alignItems="center">
      <TextLink href={localisedLink} intent={constants.PRIMARY} target="_blank">
        {intl.formatMessage(messages.helpCenter)}
        <Box display="flex" marginLeft="s">
          <ChevronRightIcon
            size={constants.MEDIUM}
            color="var(--ds-color-primary)"
          />
        </Box>
      </TextLink>
    </Stack>
  );
};
